import { render, staticRenderFns } from "./DisplayModeConfirmModal.vue?vue&type=template&id=8987c2c4&"
import script from "./DisplayModeConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DisplayModeConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports